import { Injectable } from '@angular/core';
import { CoveragePremiumInterface } from '@app/core/interfaces';
import * as fromMyZone from '@app/store/my-zone/my-zone';
import { select, Store } from '@ngrx/store';
import { NotificationInterface } from 'outshared-lib';
import { Observable } from 'rxjs';
import { filter, take } from 'rxjs/operators';
import { ClearNotifications } from './calculation.actions';
import { getAllCalculations, getFilteredCalculationsTotal, getNotifications, getSelectedCalculation } from './calculation.selectors';

@Injectable({
    providedIn: 'root',
})
export class CalculationSelectorService {

    /** @deprecated use outshared-lib - InsurancePolicyDataService */
    public getFilteredCalculationsTotal$: Observable<number> = this.store.pipe(select(getFilteredCalculationsTotal));
    /** @deprecated use outshared-lib - InsurancePolicyDataService */
    public getAllCalculations$: Observable<CoveragePremiumInterface[]> = this.store.pipe(select(getAllCalculations));
    /** @deprecated use outshared-lib - InsurancePolicyDataService */
    public getSelectedCalculation$: Observable<CoveragePremiumInterface> = this.store.pipe(select(getSelectedCalculation));
    /** @deprecated use outshared-lib - InsurancePolicyDataService */
    public getAllNotifications$: Observable<NotificationInterface[]> = this.store.pipe(select(getNotifications));

    constructor(
        private store: Store<fromMyZone.State>,
    ) { }

    /** @deprecated use outshared-lib - InsurancePolicyActionService */
    public clearNotifications(): void {
        this.getAllNotifications$.pipe(
            take(1), filter((errors) => errors.length > 0),
        ).subscribe(() => this.store.dispatch(new ClearNotifications()));
    }
}
